import React, { Component } from 'react';
import { Container, Tabs, Tab, Button, Modal } from 'react-bootstrap';
import DataTable from "react-data-table-component";
import { FaFile, FaPlus } from 'react-icons/fa6';
import { GetText, ReplaceText, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../../config/helper';
import Loading from '../../inc/Loading';
import TagHeaders from '../../inc/Headers';
import '../../config/global';
import ImgLogoGemini from '../../img/logo_gemini_academy.png';
import ImgShareThread from '../../img/pic_share_thread.png';
import DiscussionForm from '../../inc/discussion/Form';
import DiscussionBlock from '../../inc/discussion/Block';

const authKey = global.config.kindcode.training[22]+global.config.authBearerKey;

function getThreadData () {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","category":"'+global.config.bannerType[2].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/threadlist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}

async function getAllDatas(actvPage) {
    
    const [thing1] = await Promise.all([getThreadData()]);
    var arrReturnValue = {};
    arrReturnValue.threaddata = thing1
            .sort((c,d) => d.content.createDate._seconds - c.content.createDate._seconds)
            .map((threadItem, j) => {
                var threadListSend = threadItem.content;
                threadListSend.id = threadItem.docid;
                threadListSend.likeData = threadItem.subcontentlist !== undefined? threadItem.subcontentlist : [];
                threadListSend.activePage = actvPage;
                return threadListSend
            });

    return arrReturnValue;
}

export default class DiscussionBrowseMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      memberStatus: localStorage.getItem('status'),
      currentUrl: '',
      activePage: '',
      defRowPage: 1,
      threadList: [],
      threadListAll: [],
      isLoad: false,
      modal_show_thread: false,
      view_mythread: false
    }
  }
  handlePopOpen(name) {
    this.setState({ 
      [name]: true,
    });
  }
  handlePopClose(name) {
    this.setState({ 
      [name]: false,
    });
  }

  handleListThread(stat) {
    var stat_thread, result;
    if(stat === true) {
      result = this.state.threadListAll.filter((listA) =>  {
        return listA.threadStatus === global.config.threadStatus[1];
      });
      stat_thread = false;
    } else {
      result = this.state.threadListAll.filter((listA) =>  {
        return (listA.createById === this.state.memberId && listA.threadStatus !== global.config.threadStatus[2]);
      });
      stat_thread = true;
    }
    
    this.setState({
      threadList: result,
      view_mythread: stat_thread
    }) 
  }
  listThreadContent() {   
    var column = [];
    column.push({ 
      name: "Description", 
      cell: (row) => <DiscussionBlock value={{"currpage": this.state.currentUrl, "data": row, "type": "browse" }} /> 
    });

    return column;
    
  }
  componentDidMount() {    
    var currentURL = window.location.pathname;
    var arrPath = currentURL.split('/');
    
    getAllDatas(arrPath[1]).then((response) => {
      var public_data = response.threaddata.filter((listA) =>  {
        return listA.threadStatus === global.config.threadStatus[1];
      });
      this.setState({
        currentUrl: currentURL,
        activePage: arrPath[1],
        threadList: public_data,
        threadListAll: response.threaddata,
        isLoad: true
      }) 
    });
  }

  render() {
    return (
      <div className="discussion-gemini">
        <TagHeaders value={
                        {	
                          docid: '', 
                          title: 'Novaio Academy - Gemini Academy', 
                          description: '',
                          links: global.config.urlHost+this.state.currentUrl
                        }
                      }/>
        <section>
          <Container className='mb-4'>
            <div className='text-center'><img src={ImgLogoGemini} className='logo'/></div>
          </Container>
        </section>
        
        {
          this.state.isLoad === true ? 
            this.state.threadList.length > 0 ? (
              <section>
                <Container>
                  <div className="br-8">
                    {
                      GetText() ? (
                        <div>
                          <h4 className="text-start mb-1">Ruang Diskusi</h4>
                          <p className="text-start mb-4">Tempat untuk diskusi berbasis data dan semua pertanyaan, jawaban, serta antusiasme Anda tentang Gemini.</p>
                        </div>
                      ) : (
                        <div>
                          <h4 className="text-start mb-1">Discussion Room</h4>
                          <p className="text-start mb-4">The place for data-driven discussion and all your  questions, answers, and excitement about Gemini.</p>
                        </div>                      
                      )
                    }
                    <div className="row mt-3">
                      <div className="col-md-9">
                        <div className="bg-light mb-3" style={{height:"2px"}}></div>
                        {
                          (this.state.threadList.length > 0)? (
                            <DataTable 
                              columns={this.listThreadContent()}
                              data={this.state.threadList}
                              noHeader={true} // Set to true to hide the title header
                              pagination
                              paginationPerPage={this.state.defRowPage}
                              paginationRowsPerPageOptions={[1, 10, 25, 50, 75, 100]}
                              customStyles={{
                                headRow: {
                                  style: {
                                    display: "none"
                                  },
                                  denseStyle: {
                                    minHeight: "32px",
                                  },
                                }
                              }}
                            />
                            
    
                          ) : (
                            <div className="d-flex justify-content-center align-items-center">
                              {/* The content to be centered */}
                              <div className="text-center p-3">
                                <img src={ImgShareThread} width="150"/><br/>
                                <Button className="mt-2" variant="primary" size="md" type="button" value="Open Discussion" id="sharethread" onClick={this.handlePopOpen.bind(this,"modal_show_thread")}>{GetText() ? "Buka Ruang Diskusi" : "Open Discussion"}</Button>
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <div className="col-md-3 bg-light">
                       
                        <Button variant="link" size="sm" type="button" className="btn-light text-decoration-none mt-4" onClick={this.handlePopOpen.bind(this,"modal_show_thread")}>
                          <FaPlus className="style-action-icons"  style={{size: "20px"}}  />
                          <span >{GetText() ? "Buka Ruang Diskusi" : "Open Discussion"} </span>
                        </Button>
                        <Button variant="link" size="sm" type="button" className="btn-light text-decoration-none mt-4" onClick={this.handleListThread.bind(this, this.state.view_mythread)}>
                          <FaFile className="style-action-icons"  style={{size: "20px"}}  />
                          { 
                            this.state.view_mythread === true? GetText() ? "Lihat Semua Topik" : "All Topic"
                            : GetText() ? "Lihat Topik Anda" : "My Topik"
                          } 
                        </Button>
                      </div>
                    </div>
                    
                   
                  </div>
                </Container>
              </section>
            ) : <></>
            : <Loading value={{id:'discussion-area', divstyle:{}, componentstyle: {}}}/>
        }

          <Modal animation={false} show={this.state.modal_show_thread} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_thread")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Buka Ruang Diskusi" : "Open Discussion"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DiscussionForm value={{"currpage": this.state.activePage}} />
            </Modal.Body>
          </Modal>
      </div>
    );
  }
}